import React from 'react';

export const MssqlPropertyLayout = ({
  fields,
  values,
  buildFieldName = name => `mssql_${name}`,
}) => (
  <>
    <div className="heading heading-sm">
      <h3 className="h4">Adapter Properties</h3>
    </div>
    <div className="row">
      <div className="col-9">{fields.get(buildFieldName('host'))}</div>
      <div className="col-3">{fields.get(buildFieldName('port'))}</div>
      <div className="col-6">{fields.get(buildFieldName('database'))}</div>
      <div className="col-6">{fields.get(buildFieldName('instance'))}</div>
      <div className="col-6">{fields.get(buildFieldName('username'))}</div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get(buildFieldName('password'))}
          {fields.get(buildFieldName('passwordChange'))}
        </div>
      </div>
      <div className="col-6">{fields.get(buildFieldName('sslEnabled'))}</div>
      <div className="col-6">{fields.get(buildFieldName('sslProtocol'))}</div>
      <div className="col-6">
        {fields.get(buildFieldName('windowsauthenabled'))}
      </div>
    </div>
    <div className="form-group--toggle">
      {!values.get(buildFieldName('change_sslrootcert'))
        ? fields.get(buildFieldName('current_sslrootcert'))
        : fields.get(buildFieldName('sslrootcert'))}
      {fields.get(buildFieldName('change_sslrootcert'))}
    </div>
    <div className="form-group--toggle">
      {!values.get(buildFieldName('change_sslcert'))
        ? fields.get(buildFieldName('current_sslcert'))
        : fields.get(buildFieldName('sslcert'))}
      {fields.get(buildFieldName('change_sslcert'))}
    </div>
    <div className="row">
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get(buildFieldName('trustStorePassword'))}
          {fields.get(buildFieldName('trustStorePasswordChange'))}
        </div>
      </div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get(buildFieldName('keyStoreSecret'))}
          {fields.get(buildFieldName('keyStoreSecretChange'))}
        </div>
      </div>
    </div>
  </>
);

export const OraclePropertyLayout = ({
  fields,
  values,
  buildFieldName = name => `oracle_${name}`,
}) => (
  <>
    <div className="heading heading-sm">
      <h3 className="h4">Adapter Properties</h3>
    </div>
    <div className="row">
      <div className="col-9">{fields.get(buildFieldName('host'))}</div>
      <div className="col-3">{fields.get(buildFieldName('port'))}</div>
      <div className="col-12">{fields.get(buildFieldName('service'))}</div>
      <div className="col-6">{fields.get(buildFieldName('username'))}</div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get(buildFieldName('password'))}
          {fields.get(buildFieldName('passwordChange'))}
        </div>
      </div>
      <div className="col-4">{fields.get(buildFieldName('sslEnabled'))}</div>
      <div className="col-4">{fields.get(buildFieldName('sslVersion'))}</div>
      <div className="col-4">
        {fields.get(buildFieldName('sslServerDnMatch'))}
      </div>
      <div className="col-12">{fields.get(buildFieldName('ciphersuites'))}</div>
    </div>
    <div className="form-group--toggle">
      {!values.get(buildFieldName('change_serverCert'))
        ? fields.get(buildFieldName('current_serverCert'))
        : fields.get(buildFieldName('serverCert'))}
      {fields.get(buildFieldName('change_serverCert'))}
    </div>
    <div className="form-group--toggle">
      {!values.get(buildFieldName('change_clientCert'))
        ? fields.get(buildFieldName('current_clientCert'))
        : fields.get(buildFieldName('clientCert'))}
      {fields.get(buildFieldName('change_clientCert'))}
    </div>
    <div className="row">
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get(buildFieldName('trustStorePassword'))}
          {fields.get(buildFieldName('trustStorePasswordChange'))}
        </div>
      </div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get(buildFieldName('keyStorePassword'))}
          {fields.get(buildFieldName('keyStorePasswordChange'))}
        </div>
      </div>
    </div>
  </>
);

export const PostgresPropertyLayout = ({
  fields,
  values,
  buildFieldName = name => `postgres_${name}`,
}) => (
  <>
    <div className="heading heading-sm">
      <h3 className="h4">Adapter Properties</h3>
    </div>
    <div className="row">
      <div className="col-9">{fields.get(buildFieldName('host'))}</div>
      <div className="col-3">{fields.get(buildFieldName('port'))}</div>
      <div className="col-12">{fields.get(buildFieldName('database'))}</div>
      <div className="col-6">{fields.get(buildFieldName('username'))}</div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get(buildFieldName('password'))}
          {fields.get(buildFieldName('passwordChange'))}
        </div>
      </div>
      <div className="col-6">{fields.get(buildFieldName('sslEnabled'))}</div>
      <div className="col-6">{fields.get(buildFieldName('sslmode'))}</div>
    </div>
    <div className="form-group--toggle">
      {!values.get(buildFieldName('change_sslrootcert'))
        ? fields.get(buildFieldName('current_sslrootcert'))
        : fields.get(buildFieldName('sslrootcert'))}
      {fields.get(buildFieldName('change_sslrootcert'))}
    </div>
    <div className="form-group--toggle">
      {!values.get(buildFieldName('change_sslcert'))
        ? fields.get(buildFieldName('current_sslcert'))
        : fields.get(buildFieldName('sslcert'))}
      {fields.get(buildFieldName('change_sslcert'))}
    </div>
    <div className="form-group--toggle">
      {!values.get(buildFieldName('change_sslkey'))
        ? fields.get(buildFieldName('current_sslkey'))
        : fields.get(buildFieldName('sslkey'))}
      {fields.get(buildFieldName('change_sslkey'))}
    </div>
  </>
);

export const DATABASE_ADAPTER_FIELDS = spaceSlug => ({
  [`${spaceSlug ? 'task_' : ''}mssql_current_sslrootcert`]: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_mssql_sslrootcert.crt`,
    },
  },
  [`${spaceSlug ? 'task_' : ''}mssql_current_sslcert`]: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_mssql_sslcert.crt`,
    },
  },
  [`${spaceSlug ? 'task_' : ''}oracle_current_serverCert`]: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_oracle_serverCert.crt`,
    },
  },
  [`${spaceSlug ? 'task_' : ''}oracle_current_clientCert`]: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_oracle_clientCert.crt`,
    },
  },
  [`${spaceSlug ? 'task_' : ''}postgres_current_sslrootcert`]: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_postgres_sslrootcert.crt`,
    },
  },
  [`${spaceSlug ? 'task_' : ''}postgres_current_sslcert`]: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_postgres_sslcert.crt`,
    },
  },
  ...(spaceSlug
    ? {
        integrator_postgres_current_sslrootcert: {
          renderAttributes: {
            filename: `${
              spaceSlug || 'system'
            }_integrator_postgres_sslrootcert.crt`,
          },
        },
        integrator_postgres_current_sslcert: {
          renderAttributes: {
            filename: `${
              spaceSlug || 'system'
            }_integrator_postgres_sslcert.crt`,
          },
        },
      }
    : {}),
});
